import { BaseContainerModel } from '../base-container.model';
import { bl_wms_picking_cart_RowInterface, bl_wms_picking_cart_RowClass } from '../../dbschema/index';
    
export class WmsPickingCartContainer extends BaseContainerModel {
    bl_wms_picking_cart: bl_wms_picking_cart_RowInterface = new bl_wms_picking_cart_RowClass();
}
